import {GET_PATIENT_DETAILS_FAILURE, GET_PATIENT_DETAILS_REQUEST, GET_PATIENT_DETAILS_SUCCESS} from "./constants";

export function getPatientDetails(patientId) {
    return {
        type: GET_PATIENT_DETAILS_REQUEST,
        data: {patientId}
    }
}

export function getPatientDetailsSuccess(response) {
    return {
        type: GET_PATIENT_DETAILS_SUCCESS,
        data: response
    }
}

export function getPatientDetailsFailure() {
    return {
        type: GET_PATIENT_DETAILS_FAILURE,
        data: {}
    }
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/PatientDetails/actions.js